import { Box, Typography } from '@mui/material';
import { IVerbaScholaAiGeneration } from '../api/VerbaScholaLessonAiApi';
import { PinyinReview } from './VerbaScholaPinyinReview';
import { instructionalPinyin } from './studentInstructionalPinyin';
import LessonText from './LessonText';

// One phrase per step type that saved_exercise_summary counts (singular, plural).
const labels: Record<string, [string, string]> = { quiz_question: ['quiz question', 'quiz questions'],
    speak_with_grade: ['speaking activity', 'speaking activities'], type_speak: ['typed-answer activity', 'typed-answer activities'],
    conversation_listen: ['dialogue', 'dialogues'],
    image: ['picture', 'pictures'], introduce_word: ['word introduction', 'word introductions'],
    summary: ['speaking summary', 'speaking summaries'], select_next_dialog: ['what-comes-next choice', 'what-comes-next choices'],
    quiz_question_audio: ['audio quiz question', 'audio quiz questions'], quiz_word: ['word quiz', 'word quizzes'],
    match_game: ['match game', 'match games'], image_select_speak: ['picture choose-and-speak activity', 'picture choose-and-speak activities'],
    quiz_question_speak: ['quiz-and-speak question', 'quiz-and-speak questions'],
    listen_speak: ['listen-and-repeat activity', 'listen-and-repeat activities'],
    listen_speak_no_grade: ['ungraded listen-and-repeat activity', 'ungraded listen-and-repeat activities'],
    speak_no_grade: ['free speaking question', 'free speaking questions'],
    type_speak_v2: ['write-your-own-then-say activity', 'write-your-own-then-say activities'],
    conversation_listen_without_character: ['listen-only dialogue', 'listen-only dialogues'],
    conversation_listen_speak: ['listen-then-speak dialogue', 'listen-then-speak dialogues'],
    conversation_read_speak: ['read-and-speak dialogue', 'read-and-speak dialogues'],
    conversation_speak_only: ['from-memory dialogue', 'from-memory dialogues'],
    conversation_read_with_blank_speak: ['fill-the-gaps dialogue', 'fill-the-gaps dialogues'],
    write_open: ['open writing response', 'open writing responses'], speak_open: ['open speaking response', 'open speaking responses'],
    type_speak_open: ['write-and-speak response', 'write-and-speak responses'] };
// A type added later still reads as words, never as an internal identifier.
const label = (kind: string, count: number) => labels[kind]?.[count === 1 ? 0 : 1] ?? kind.replaceAll('_', ' ');

export function SavedExerciseSummary({ job }: { job: IVerbaScholaAiGeneration }) {
    const summary = job.saved_exercise_summary;
    if (!summary) return null;
    return <Box aria-label="Saved exercise summary" sx={{ my: 1 }}>
        <Typography variant="body2">Saved: {summary.exercises} {summary.exercises === 1 ? 'exercise' : 'exercises'};
            {' '}{Object.entries(summary.activity_counts).filter(([, count]) => count > 0)
                .map(([kind, count]) => `${count} ${label(kind, count)}`).join(', ')}.</Typography>
        {summary.quiz_answers.length > 0 && <>
            <Typography variant="body2" fontWeight={600} sx={{ mt: 1 }}>Draft answer keys</Typography>
            <Typography variant="caption" color="text.secondary">Check these before marking the exercises ready.</Typography>
            {summary.quiz_answers.map((answer, index) => <Box key={index} sx={{ mt: 1 }}>
                <Typography variant="caption" color="text.secondary">{answer.exercise_title}</Typography>
                <LessonText variant="body2">Question: {answer.prompt_text}</LessonText>
                <Typography variant="body2">Correct answer: {answer.answer_text}
                    {answer.answer_pinyin.length > 0 ? ` (${instructionalPinyin(answer.answer_pinyin)})` : ''}</Typography>
            </Box>)}
        </>}
        <PinyinReview review={summary.pinyin_review} />
    </Box>;
}
